import React from "react";

interface Props {
  data: number[];
  color: string;
  label: string;
}

const TrendChart: React.FC<Props> = ({ data, color, label }) => {
  const max = Math.max(...data);
  const min = Math.min(...data);
  const range = max - min;
  const height = 60;
  const width = 200;

  const points = data.map((val, i) => {
    const x = (i / (data.length - 1)) * width;
    const y = height - ((val - min) / (range || 1)) * height;
    return `${x},${y}`;
  }).join(" ");

  return (
    <div style={{ background: "#fff", padding: "16px", borderRadius: "12px", border: "1px solid #f1f5f9", flex: 1 }}>
      <p style={{ margin: "0 0 8px 0", fontSize: "12px", color: "#64748b", fontWeight: 600, textTransform: "uppercase" }}>{label}</p>
      <div style={{ display: "flex", alignItems: "flex-end", gap: "12px" }}>
        <h4 style={{ margin: 0, fontSize: "20px", fontWeight: 700, color: "#1e293b" }}>{data[data.length - 1].toLocaleString()}</h4>
        <svg width={width} height={height} style={{ overflow: "visible" }}>
          <polyline
            fill="none"
            stroke={color}
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
            points={points}
          />
          {/* Subtle Area under curve */}
          <path
            d={`M 0,${height} L ${points} L ${width},${height} Z`}
            fill={color}
            fillOpacity="0.05"
          />
        </svg>
      </div>
    </div>
  );
};

export default TrendChart;
